export function empresaOperavel(status) {
	const s = String(status || "").trim();
	if (!s) return true;
	return s.toLowerCase() === "aprovado";
}

export function statusCadastroLabel(status) {
	const s = String(status || "").trim();
	if (!s) return "—";
	if (s.toLowerCase() === "pendente") return "Em análise";
	return s;
}

export function statusCadastroClass(status) {
	if (empresaOperavel(status)) return "is-ok";
	const s = String(status || "").toLowerCase();
	if (s.includes("pend") || s.includes("anál") || s.includes("analis")) return "is-warn";
	return "is-muted";
}
